import React from 'react'
import { ReactComponent as NoDataImage } from 'assets/shared/NotFound.svg'
import './NoDataFallback.scss'

interface NoDataFallbackProps {
  message?: string
}

const NoDataFallback: React.FC<NoDataFallbackProps> = ({
  message = 'No Data Found'
}) => {
  return (
    <div className="no-data-fallback">
      <NoDataImage className="no-data-fallback__image" />
      <p className="no-data-fallback__text">{message}</p>
    </div>
  )
}

export default NoDataFallback
